import { useTaskCache } from "src/data/taskManagement/taskManagementQueryCache"
import { useMinutPost } from "src/hooks/minutQuery"

export function usePostCreateTask() {
  const taskCache = useTaskCache()

  return useMinutPost<"/organizations/{organization_id}/tasks", "403">({
    pathFn: (path) => `/organizations/${path.organization_id}/tasks`,
    options: {
      onSuccess: () => {
        return taskCache.invalidateTaskList()
      },
    },
  })
}
